import { asPage } from 'src/components/hoc/asPage'
import { Auth } from 'src/compositions/Auth'

export default asPage(Auth, { pageTitle: 'ログイン', noindex: true })
